export default __webpack_public_path__ + "static/media/11.416d63d6.jpg";